import { CampaignsState } from './types'

export const initialCampaignsState: CampaignsState = {
  entries: {},
  pagination: {},
}
